module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Kanban Cute")]), _vm._v(" "), _c('div', {}, [_c('b-btn', {
    on: {
      "click": function($event) {
        _vm.$root.$emit('show::modal', 'modal1')
      }
    }
  }, [_vm._v("Add a Card")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal1",
      "title": "Add Card"
    }
  }, [_c('form', [_c('p', [_vm._v("Task: ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "--Title task--"
    },
    model: {
      value: (_vm.task),
      callback: function($$v) {
        _vm.task = $$v
      },
      expression: "task"
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Description: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "rows": "4",
      "cols": "50"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Assigned To: ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "--Assigned To--"
    },
    model: {
      value: (_vm.assignee),
      callback: function($$v) {
        _vm.assignee = $$v
      },
      expression: "assignee"
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Point:")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "--Point--"
    },
    model: {
      value: (_vm.point),
      callback: function($$v) {
        _vm.point = $$v
      },
      expression: "point"
    }
  }), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "success"
    },
    on: {
      "click": _vm.addTask
    }
  }, [_vm._v("Submit")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1afc7828","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 187
// module chunks = 1